import React, { Component } from 'react';
import Box from '../ui/Box';

import RoomPower from './RoomPower';

export default class PowerMain extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <Box header='Power Consumption Stats'>
        <RoomPower className="col-sm-12 ml-3-2vw mt-1vw h-100 p-0" />
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/power/PowerMain.js